import { EFinancingProgram } from '@if/core/types'
import PageSpinner from '@src/components/PageSpinner'
import { useUser } from '@src/contexts/AppContext'
import { useCreditApplicationById } from '@src/data/api/credit-api/credit-api'
import { useMerchantById, useMerchantByParentId } from '@src/data/api/merchants-api/merchants-api'
import { Navigate } from 'react-router-dom'
import CreateWorksheetPage from '.'

interface Props {
  id: string
  financingProgramId: EFinancingProgram
}
const WorksheetWrapper = ({ id, financingProgramId }: Props) => {
  const [creditApplication, isLoading] = useCreditApplicationById(
    { creditApplicationId: id, financingProgramId },
    false,
  ) // if true, poll every 5 secs
  const user = useUser()
  const [merchant, isLoadingMerchant] = useMerchantById(creditApplication?.merchantId ?? '')
  const [merchantsListFromParentId, isFetchingMerchantsList] = useMerchantByParentId(user?.merchantId ?? '')
  const isLoadingInfo = isLoading || isLoadingMerchant || isFetchingMerchantsList
  if (!isLoadingInfo) {
    if (!user || !merchant || !merchantsListFromParentId || !creditApplication) {
      return <Navigate to="/" />
    }

    return (
      <CreateWorksheetPage
        creditApplication={creditApplication}
        merchant={merchant}
        user={user}
        merchantsListFromParentId={merchantsListFromParentId}
      />
    )
  }
  return <PageSpinner withBackdrop isLoading={isLoadingInfo} />
}
export default WorksheetWrapper
